export interface Testimonial {
  name: string;
  content: string;
  image: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Aditi S*****h's Mother, 48",
    content:
      "As parents (especially of a single daughter), my husband and I have always been anxious when our daughter is traveling alone. With Cohop, I know she has a trusted companion. Since we know there is also a woman behind this initiative, the peace of mind is priceless.",
    image: "testimonials/6.jpg",
  },
  {
    name: "Riya S*****a, 24",
    content:
      "I was nervous about taking a late-night cab after my flight, but with Cohop, I found another female traveler going the same way. We shared the ride and ended up chatting the whole way. Both of us felt completely safe.",
    image: "/testimonials/1.jpg",
  },
  {
    name: "Priya R*****i's Father, 52",
    content:
      "When my daughter told me she had to travel alone to Bengaluru, I was worried. But with Cohop, she connected with another verified woman traveler. Knowing she wasn't alone made me so much more at ease. Thanks to the diligent team!",
    image: "/testimonials/4.jpg",
  },
  {
    name: "Ananya B*****e, 27",
    content:
      "I love how easy it is to find other women traveling the same route. And it's not only safe but also another way to network. I've made some amazing friends through Cohop.",
    image: "testimonials/2.jpg",
  },
  {
    name: "Meera K*****i, 21",
    content:
      "Being new to the city, I didn't know anyone. Cohop helped me find a female co-passenger who made me feel safe and comfortable. Bonus points because she was also super fun to talk to. It made the journey so much better.",
    image: "testimonials/3.jpg",
  },
  {
    name: "Shreya J*****n, 29",
    content:
      "Safety is always my top priority when traveling. With Cohop, I feel in control because I get to choose who I share my ride with, and I know they're verified.",
    image: "testimonials/5.jpg",
  },
];
